{{#unless availableMeterValues}}
<div class="row">
	<div class="col-sm-12">
		<div class="card-box clearfix">
			<h3>Keine Daten verfügbar</h3>
			<p>{{TR 'Dieses Gerät liefert momentan keine Zählerwerte.'}}</p>
		</div>
	</div>
</div>
{{else}}
{{#if selectedMeterGraphs}}
<div class="row p-b-10">
	<div class="col-sm-12">
		<h4 class="page-title">{{TR 'Analyse'}}</h4>
	</div>
</div>
<div class="row">
	{{#each selectedMeterGraphs}}
	<div class="col-md-6">
		<div id="h-analyse" class="card-box widget-box-1 bg-white">
			<a href="#" id="js-tile-g-{{@index}}" class="js-remove text-muted pull-right">X</a>
			<h4 class="text-dark">{{TR_DATAPOINT ../id spec.attributes.name}}{{#COMPARE this.type '==' 'g-eop_table'}} ({{this.display}}){{/COMPARE}}</h4>
			{{#COMPARE this.type '==' 'graph'}}
			<div class="chart-wrapper">
				<div class="dygraph-legend-extern" id="chart-legend-{{@index}}"></div>
				<div class="chart-container">
					<div class="chart-linear" id="chart-{{@index}}" data-legend="{{@index}}" style="width:100%">
						<i class="fa fa-spin fa-spinner"></i>
					</div>
				</div>
			</div>
			<div id="chart-time-selector-{{@index}}" class="row invisible">
				<div class="col-sm-12">
					<div class="btn-group m-t-15 pull-right">
						<button id="h-timespan" type="button" class="btn btn-white dropdown-toggle" data-toggle="dropdown">
							<span>{{display}}</span> <span class="caret"></span>
						</button>
						<ul class="dropdown-menu" role="menu">
							<li><a href="#" class="js-time-select" id="js-g-{{@index}}-hour">{{TR 'Stunden'}}</a></li>
							<li><a href="#" class="js-time-select" id="js-g-{{@index}}-day">{{TR 'Tage'}}</a></li>
							<li><a href="#" class="js-time-select" id="js-g-{{@index}}-week">{{TR 'Wochen'}}</a></li>
							<li><a href="#" class="js-time-select" id="js-g-{{@index}}-month">{{TR 'Monate'}}</a></li>
						</ul>
					</div>
					<div class="btn-group m-t-15 pull-right m-r-10">
						<button id="h-csv" type="button" class="btn btn-white js-export-csv" id="export-csv-ct" data-chart="{{@index}}">
							{{TR "Export CSV"}}
						</button>
					</div>
				</div>
			</div>
			{{else}}
			{{#if ../eop}}
			<div class="row">
				<div class="col-sm-12">
					<table class="graph-values" style="width: 100%"><tbody>
						<tr>
							<th></th>
							{{#each ../eop.years}}
							{{#if @last}}
							{{#COMPARE ../mode '!=' 'year'}}
							<th class="table-column-heading" style="text-align: right">{{this}}</th>
							{{/COMPARE}}
							{{else}}
							<th class="table-column-heading" style="text-align: right">{{this}}</th>
							{{/if}}
							{{/each}}
						</tr>
						{{#each ../eop.data}}
						<tr>
							<td class="table-column-heading">{{month}}</td>
							{{#COMPARE ../mode '==' 'eop'}}
							{{#each data}}
							<td style="padding-right: 5px; text-align: right">
								{{#if this.value}}
									<small>
									{{#if this.status.outCounter}}<i class="fa fa-caret-up" /> {{this.status.outCounter}} kWh{{/if}}
									{{#if this.status.inCounter}}<i class="fa fa-caret-down" /> {{this.status.inCounter}} kWh{{/if}}
									</small>
									{{#if this.status.replaced}}<br>{{/if}}
									{{#if this.status.icon}}
									<span class="text-muted">{{this.status.icon}}&nbsp;{{this.value}}</span>
									{{else}}
									<span class="text-custom">{{this.value}}</span>
									{{/if}}
								{{else}}--{{/if}}
							</td>
							{{/each}}
							{{/COMPARE}}
							{{#COMPARE ../mode '==' 'consumption'}}
							{{#each consumption}}
							<td style="padding-right: 5px; text-align: right">
								{{#if this.value}}
									{{#if this.status.icon}}
									<span class="text-muted">{{#COMPARE this.status.icon '!=' '~'}}<i class="fa fa-{{this.status.icon}}" />{{else}}~{{/COMPARE}}&nbsp;{{this.value}}</span>
									<span class="m-r-5">&nbsp;</span>
									{{else}}
									<span class="text-custom">{{this.value}}</span>
									{{/if}}
									{{#if this.status.trendIcon}}
									<span class="{{this.status.trendClass}}">{{{this.status.trendIcon}}}</span>
									{{else}}
									<span class="m-r-5">&nbsp;</span>
									{{/if}}
								{{else}}
								--
								<span class="m-r-5">&nbsp;</span>
								{{/if}}
							</td>
							{{/each}}
							{{/COMPARE}}
							{{#COMPARE ../mode '==' 'year'}}
							{{#each twelveMonth}}
							{{#unless @last}}
							<td style="padding-right: 5px; text-align: right">
								{{#if this.value}}
									{{#COMPARE this.count '==' 12}}
									{{#if this.status.icon}}
									{{this.status.icon}}&nbsp;{{this.value}}
									{{else}}
									<span class="text-custom">{{this.value}}</span>
									{{/if}}
									{{#if this.status.trendIcon}}
									<span class="{{this.status.trendClass}}">{{{this.status.trendIcon}}}</span>
									{{else}}
									<span class="m-r-5">&nbsp;</span>
									{{/if}}
									{{#if this.ausnutzung}}
									<small>({{this.ausnutzung}})</small>
									{{/if}}
									{{else}}
									--
									<span class="m-r-5">&nbsp;</span>
									{{/COMPARE}}
								{{else}}
								--
								<span class="m-r-5">&nbsp;</span>
								{{/if}}
							</td>
							{{/unless}}
							{{/each}}
							{{/COMPARE}}
						</tr>
						{{/each}}
					<tbody></table>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-7">
					<div class="m-t-15">
					{{#COMPARE mode '==' 'eop'}}
					~&nbsp;-&nbsp;{{TR 'letzter übertragener Zählerstand'}}
					| <i class="fa fa-caret-down" /><i class="fa fa-caret-up" />&nbsp;-&nbsp;{{TR 'Einbau- / Ausbau-Zählerstand'}}
					{{else}}
					~&nbsp;-&nbsp;{{TR 'basierend auf letztem übertragenen Zählerstand'}}
					{{/COMPARE}}
					{{#COMPARE mode '==' 'consumption'}}
					| <i class="fa fa-exchange" />&nbsp;-&nbsp;{{TR 'Zählerwechsel'}}
					{{/COMPARE}}
					{{#COMPARE mode '!=' 'eop'}}
					<br>
					{{TR 'Vergleich zum Vorjahresmonat'}}: &#x2B66;&#x2B69; &#177; >10% - &#x2191;&#x2193; &#177; >50% - &#x2B85;&#x2B87; &#177; >100%
					{{/COMPARE}}
					</div>
				</div>
				<div class="col-sm-5">
					<div class="btn-group m-t-15 pull-right">
						<button id="eop-mode" type="button" class="btn btn-white dropdown-toggle" data-toggle="dropdown">
							<span>{{display}}</span> <span class="caret"></span>
						</button>
						<ul class="dropdown-menu" role="menu">
							<li><a href="#" class="js-eop-mode-select" id="js-g-{{@index}}-eop">{{TR 'Zählerstand'}}</a></li>
							<li><a href="#" class="js-eop-mode-select" id="js-g-{{@index}}-consumption">{{TR 'Verbrauch'}}</a></li>
							<li><a href="#" class="js-eop-mode-select" id="js-g-{{@index}}-year">{{TR '12-Monatsverbrauch'}}</a></li>
						</ul>
					</div>
					<div class="btn-group m-t-15 pull-right m-r-10">
						<button id="export-eop-{{@index}}-csv" type="button" class="btn btn-white js-export-eop-csv">
							{{TR "Export CSV"}}
						</button>
					</div>
				</div>
			</div>

			{{else}}
			<div class="alert alert-info m-t-20">{{TR 'Keine Daten vorhanden.'}}</div>
			{{/if}}
			{{/COMPARE}}
		</div>
	</div>
	{{#COMPARE @index 'rowEnd' 2}}
	<div class="clearfix" />
	{{/COMPARE}}
	{{/each}}
</div>
{{/if}}
<div id="h-meter" class="exposed-background row p-b-10">
	<div class="col-sm-12">
		<h4 class="page-title">{{TR 'Zählerwerte'}}</h4>
		{{#if last_seen}}
		<small>{{TR 'Letzte Aktualisierung'}}: {{TIME last_seen}}</small>
		{{/if}}
	</div>
</div>
<div class="row">
	{{#each selectedMeterValues}}
	<div class="col-md-4">
		<div class="card-box widget-box-1 bg-white">
			<a href="#" id="js-tile-v-{{@index}}" class="js-remove text-muted pull-right">X</a>
			<h4 class="text-dark">{{TR_DATAPOINT ../id spec.attributes.name}}</h4>
			<h2 class="text-custom text-center">
				{{data}} {{unit}}
			</h2>
		</div>
	</div>
	{{#COMPARE @index 'rowEnd' 3}}
	<div class="clearfix" />
	{{/COMPARE}}
	{{/each}}
	{{#unless selectedMeterValues}}
	<div class="col-sm-12">
		<div class="card-box clearfix">
			<div class="alert alert-info m-t-20">{{TR 'Keine Zählerwerte ausgewählt.'}}</div>
		</div>
	</div>
	{{/unless}}
</div>
{{/unless}}
